'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _immutable = require('immutable');

var _util = require('../../util');

var _util2 = _interopRequireDefault(_util);

var _component = require('./component');

var _lodashCompat = require('lodash-compat');

var _util3 = require('./util');

var _data = require('../../util/data');

var _headFilter = require('./component/head-filter');

var _spin = require('../../spin');

var _spin2 = _interopRequireDefault(_spin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

Function.prototype.$asyncbind = function $asyncbind(self, catcher) {
  var resolver = this;

  if (catcher === true) {
    if (!Function.prototype.$asyncbind.EagerThenable) Function.prototype.$asyncbind.EagerThenable = function factory(tick) {
      var _tasks = [];

      if (!tick) {
        try {
          tick = process.nextTick;
        } catch (ex) {
          tick = function tick(p) {
            setTimeout(p, 0);
          };
        }
      }

      function _untask() {
        for (var i = 0; i < _tasks.length; i += 2) {
          var t = _tasks[i + 1],
              r = _tasks[i];

          for (var j = 0; j < t.length; j++) {
            t[j].call(null, r);
          }
        }

        _tasks = [];
      }

      function isThenable(obj) {
        return obj && obj instanceof Object && typeof obj.then === 'function';
      }

      function EagerThenable(resolver) {
        function done(inline) {
          var w;
          if (_sync || phase < 0 || (w = _thens[phase]).length === 0) return;

          _tasks.push(result, w);

          _thens = [[], []];
          if (_tasks.length === 2) inline ? _untask() : tick(_untask);
        }

        function resolveThen(x) {
          if (isThenable(x)) return x.then(resolveThen, rejectThen);
          phase = 0;
          result = x;
          done(true);
        }

        function rejectThen(x) {
          if (isThenable(x)) return x.then(resolveThen, rejectThen);
          phase = 1;
          result = x;
          done(true);
        }

        function settler(resolver, rejecter) {
          _thens[0].push(resolver);

          _thens[1].push(rejecter);

          done();
        }

        function toString() {
          return 'EagerThenable{' + {
            '-1': 'pending',
            0: 'resolved',
            1: 'rejected'
          }[phase] + '}=' + result.toString();
        }

        this.then = settler;
        this.toString = toString;
        var _thens = [[], []],
            _sync = true,
            phase = -1,
            result;
        resolver.call(null, resolveThen, rejectThen);
        _sync = false;
        done();
      }

      EagerThenable.resolve = function (v) {
        return isThenable(v) ? v : {
          then: function then(resolve, reject) {
            return resolve(v);
          }
        };
      };

      return EagerThenable;
    }();
    return new Function.prototype.$asyncbind.EagerThenable(boundThen);
  }

  if (catcher) {
    if (Function.prototype.$asyncbind.wrapAsyncStack) catcher = Function.prototype.$asyncbind.wrapAsyncStack(catcher);
    return then;
  }

  function then(result, error) {
    try {
      return result && result instanceof Object && typeof result.then === 'function' ? result.then(then, catcher) : resolver.call(self, result, error || catcher);
    } catch (ex) {
      return (error || catcher)(ex);
    }
  }

  function boundThen(result, error) {
    return resolver.call(self, result, error);
  }

  boundThen.then = boundThen;
  return boundThen;
};

/**
 * FIXME: set和get方法输入与输出的格式不一致
 */
var ComplexRecords = (_temp = _class = function (_M$BaseComponent$Mixi) {
  _inherits(ComplexRecords, _M$BaseComponent$Mixi);

  // FIXME: 补全

  function ComplexRecords(props) {
    _classCallCheck(this, ComplexRecords);

    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(ComplexRecords).call(this, props));

    _this.defaultActions = {
      search: function search(records) {
        return records.search();
      },
      reset: function reset(records) {
        return records.reset();
      }
    };
    _this.defaultPageSize = 20;
    var model = props.model;

    // 已经作为搜索的字段

    var searchFieldsMap = {};

    var _ref = model && model.search || {};

    var fields = _ref.fields;

    fields.forEach(function (item) {
      return searchFieldsMap[item.code] = item;
    });
    // 表头筛选允许搜索的字段

    var _ref2 = model && model.grid || {};

    var columns = _ref2.columns;
    var scroll = _ref2.scroll;

    var dataColumns = [];
    (columns || []).forEach(function (item) {
      // FIXME: 这里需要注意：
      // 初始存入dataColumn的是不带有值的，之后每次操作修改同一对象，使得表头筛选组件接收到了新值，
      // 组件重新渲染，但是因为表头内部组件无法直接控制，暂时没别的办法处理值传递。
      dataColumns.push([item.code, Object.assign(_this._formatTableHead(item), {
        show: item.show !== false
      })]);
      // 如果存在表头筛选
      if (!!item.filterModel) {
        searchFieldsMap[item.code] = item;
        searchFieldsMap[item.code].filterType = item.filterModel.type;
      }
    });

    Object.assign(_this.state, {
      condition: (0, _immutable.OrderedMap)(), // 搜索条件
      changedKeys: [], // 当前变动的字段主键集合
      dataTotalCount: 0, // 数据总条数
      pageNo: 1, // 当前页码
      pageSize: model.pageSize || _this.defaultPageSize, // 当前每页条数
      selection: [], // 已选中数据项的标识
      data: [], //当前数据
      searchFieldsMap: searchFieldsMap, //搜索字段配置
      dataColumns: (0, _immutable.OrderedMap)(dataColumns), //数据列表配置
      gridScroll: scroll, //表格滚动设置
      loadingCondition: false });
    return _this;
  }

  _createClass(ComplexRecords, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      return new Promise(function ($return, $error) {
        return Promise.resolve(this._initCondition()).then(function ($await_15) {
          return $return();
        }.$asyncbind(this, $error), $error);
      }.$asyncbind(this));
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props;
      var prefixCls = _props.prefixCls;
      var model = _props.model;
      var _state = this.state;
      var pageNo = _state.pageNo;
      var dataTotalCount = _state.dataTotalCount;
      var pageSize = _state.pageSize;
      var selection = _state.selection;
      var data = _state.data;
      var loading = _state.loading;
      var dataColumns = _state.dataColumns;
      var gridScroll = _state.gridScroll;
      var loadingCondition = _state.loadingCondition;

      var baseCls = prefixCls + '-complex-records';

      var grid = Object.assign({}, model.grid, {
        columns: dataColumns.toArray(),
        scroll: gridScroll
      });
      if (grid.pagination !== false) {
        grid.pagination = _extends({
          size: 'small' }, grid.pagination || {}, {
          current: pageNo,
          total: dataTotalCount,
          pageSize: pageSize,
          onChange: this._setPagination,
          onShowSizeChange: this._setPagination
        });
      }
      if (grid.rowSelection !== false) {
        grid.rowSelection = _extends({}, grid.rowSelection || {}, {
          selectedRowKeys: selection,
          onChange: function onChange(selection) {
            return _this2.setState({ selection: selection });
          }
        });
      }
      return _react2.default.createElement(
        'div',
        { className: this.classNames(baseCls) },
        _react2.default.createElement(ComplexRecords.Search, {
          getInstanceRef: function getInstanceRef(i) {
            return _this2.searchArea = i;
          },
          className: baseCls + '__search',
          model: model.search }),
        _react2.default.createElement(
          'div',
          { className: baseCls + '__search-info' },
          _react2.default.createElement(
            'span',
            { className: baseCls + '__result-number' },
            '搜索结果：',
            dataTotalCount
          ),
          _react2.default.createElement(ComplexRecords.SearchCondition, {
            className: baseCls + '__search-condition',
            model: model.search })
        ),
        _react2.default.createElement(
          'div',
          { className: baseCls + '__operation' },
          _react2.default.createElement(ComplexRecords.Console, {
            className: baseCls + '__console',
            model: model.console,
            data: this._getSelection() }),
          _react2.default.createElement(ComplexRecords.Setting, {
            className: baseCls + '__setting',
            model: model.setting })
        ),
        _react2.default.createElement(ComplexRecords.DataGrid, {
          className: baseCls + '__data-grid',
          model: grid,
          data: data,
          loading: loading }),
        loadingCondition && _react2.default.createElement(_spin2.default, { className: baseCls + '__loading' })
      );
    }

    /**
     * 初始化搜索条件
     */

  }, {
    key: '_initCondition',
    value: function _initCondition() {
      return new Promise(function ($return, $error) {
        var _props2 = this.props;
        var onInitCondition = _props2.onInitCondition;
        var onInitFilter = _props2.onInitFilter;

        if ((0, _lodashCompat.isFunction)(onInitCondition)) {
          console.warn('onInitCondition 即将弃用，请替换为 onInitFilter，用法不变');
        }
        var condition = {};
        var initCondition = (0, _lodashCompat.isFunction)(onInitFilter) && onInitFilter || (0, _lodashCompat.isFunction)(onInitCondition) && onInitCondition;

        function $IfStatement_7() {
          return $return();
        }

        if (initCondition) {
          this.setState({ loadingCondition: true });
          return Promise.resolve(initCondition()).then(function ($await_16) {
            var filter = $await_16;
            var searchFieldsMap = this.state.searchFieldsMap;

            Object.keys(filter).forEach(function (item) {
              var field = searchFieldsMap[item];
              // 可能会处理到showCode，直接跳过
              if (field) {
                var fieldType = field.filterType || field.type;
                var isHeadFilter = !!field.filterType;

                (function () {
                  var _condition$item;

                  switch (fieldType) {
                    case 'select':
                    case 'treeSelect':
                      var model = field.model || field.conf && field.conf.model;
                      isHeadFilter && (model = field.filterModel);
                      var _model = model;
                      var idField = _model.idField;
                      var showField = _model.showField;

                      var idFieldValue = void 0,
                          showFieldValue = void 0;
                      if ((0, _lodashCompat.isObject)(filter[item])) {
                        idFieldValue = filter[item][idField];
                        showFieldValue = filter[item][showField];
                      } else {
                        var showCode = field.showCode || item + 'Name';
                        idFieldValue = filter[item];
                        showFieldValue = filter[showCode];
                      }
                      condition[item] = (_condition$item = {
                        value: idFieldValue,
                        label: showFieldValue
                      }, _defineProperty(_condition$item, idField, idFieldValue), _defineProperty(_condition$item, showField, showFieldValue), _condition$item);
                      break;
                    case 'multiSelect':
                    case 'multiTreeSelect':
                      condition[item] = [];
                      if ((0, _lodashCompat.isArray)(filter[item])) {
                        (function () {
                          var model = field.model || field.conf && field.conf.model;
                          isHeadFilter && (model = field.filterModel);
                          var _model2 = model;
                          var idField = _model2.idField;
                          var showField = _model2.showField;

                          filter[item].forEach(function (obj) {
                            var _condition$item$push;

                            var idFieldValue = obj[idField];
                            var showFieldValue = obj[showField];
                            condition[item].push((_condition$item$push = {
                              value: idFieldValue,
                              label: showFieldValue
                            }, _defineProperty(_condition$item$push, idField, idFieldValue), _defineProperty(_condition$item$push, showField, showFieldValue), _condition$item$push));
                          });
                        })();
                      }
                      break;
                    case 'radio':
                      var radioData = field.range || field.conf && (field.conf.range || field.conf.model) || [];
                      condition[item] = Object.assign({}, radioData.find(function (obj) {
                        return obj.value === filter[item];
                      }));
                      break;
                    case 'checkbox':
                      var checkboxData = field.range || field.conf && (field.conf.range || field.conf.model) || [];
                      condition[item] = [];
                      filter[item].forEach(function (obj) {
                        var result = checkboxData.find(function (d) {
                          return obj === d.value;
                        });
                        if (result) {
                          condition[item].push({
                            value: result.value,
                            label: result.label
                          });
                        }
                      });
                      break;
                    default:
                      condition[item] = filter[item];
                  }
                })();
              }
            });
            this.setState({ loadingCondition: false });
            !(0, _lodashCompat.isEmpty)(condition) && this._setCondition(condition);
            return $IfStatement_7.call(this);
          }.$asyncbind(this, $error), $error);
        } else {
          return Promise.resolve(this._fetchData()).then(function ($await_17) {
            return $IfStatement_7.call(this);
          }.$asyncbind(this, $error), $error);
        }
      }.$asyncbind(this));
    }

    /**
     * 根据当前搜索条件和分页条件重新获取并设置数据
     */

  }, {
    key: '_fetchData',
    value: function _fetchData() {
      return new Promise(function ($return, $error) {
        var $Try_1_Finally = function ($Try_1_Exit) {
          return function ($Try_1_Value) {
            this.setState({ loading: false });
            return $Try_1_Exit && $Try_1_Exit.call(this, $Try_1_Value);
          }.$asyncbind(this, $error);
        }.$asyncbind(this);

        var $Try_1_Catch = function ($exception_2) {
          return $Try_1_Finally($error)($exception_2);
        }.$asyncbind(this, $Try_1_Finally($error));

        function $Try_1_Post() {
          return $return();
        }

        var fetchData = this.props.fetchData;

        var filter = this.getFilter();
        this.setState({ loading: true });
        try {
          return Promise.resolve(new Promise(function ($return, $error) {
            var $logicalAnd_3;

            function $IfStatement_8() {
              return $return($logicalAnd_3);
            }

            if ($logicalAnd_3 = fetchData) {
              return Promise.resolve(fetchData(filter)).then(function ($await_18) {
                $logicalAnd_3 = $await_18;
                return $IfStatement_8.call(this);
              }.$asyncbind(this, $error), $error);
            }

            return $IfStatement_8.call(this);
          }.$asyncbind(this))).then(function ($await_19) {
            var res = $await_19;
            if (res) {
              this.setState({
                data: res.pageList || [],
                dataTotalCount: (0, _lodashCompat.get)(res, 'page.totalCount', 0)
              });
            }
            return $Try_1_Finally($Try_1_Post).call(this);
          }.$asyncbind(this, $Try_1_Catch), $Try_1_Catch);
        } catch ($exception_2) {
          $Try_1_Catch($exception_2)
        }
      }.$asyncbind(this));
    }

    /**
     * 设置分页条件，置空参数将被忽略
     * 比如 setPagination(2) 只设置当前页码为 2，setPagination(undefined, 10) 只设置分页大小为 10
     */

  }, {
    key: '_setPagination',
    value: function _setPagination(pageNo, pageSize) {
      return new Promise(function ($return, $error) {
        this.setState((0, _lodashCompat.pick)({ pageNo: pageNo, pageSize: pageSize }, function (v) {
          return !(0, _data.isEmptyString)(v);
        }), this._fetchData);
        return $return();
      }.$asyncbind(this));
    }

    /**
     * 设置表头筛选
     * @param code
     * @param v
     * @private
     */

  }, {
    key: '_setHeadFilter',
    value: function _setHeadFilter(code, v) {
      this._setCondition(_defineProperty({}, code, v));
    }

    /**
     * 增加表头筛选
     * @param model
     * @returns {*}
     */

  }, {
    key: '_formatTableHead',
    value: function _formatTableHead(model) {
      var _this3 = this;

      var m = _extends({}, model);
      var code = m.code;
      var filterModel = m.filterModel;

      var _ref3 = filterModel || {};

      var filterType = _ref3.type;


      var extra = {};
      if (!!filterType) {
        // 默认弹在本组件
        extra.filterPopupContainer = function () {
          return (0, _reactDom.findDOMNode)(_this3);
        };
        var Component = void 0;
        switch (filterType) {
          case 'text':
            Component = _headFilter.TextFilter;
            break;
          case 'select':
            // case 'treeSelect':
            Component = _headFilter.SelectFilter;
            break;
          case 'multiSelect':
            // case 'treeMultiSelect':
            Component = _headFilter.MultiSelectFilter;
            break;
        }
        if (Component) {
          // 排除掉filterDropdown的model向内传入
          delete m.filterDropdown;
          extra.filterDropdown = _react2.default.createElement(Component, {
            model: m,
            onCancel: function onCancel() {
              _this3._setFieldColumn(code, Object.assign(_this3.state.dataColumns.get(code), {
                filterDropdownVisible: false
              }));
            },
            onConfirm: this._setHeadFilter.bind(this, code) });
        }
      }
      return Object.assign(m, extra);
    }

    /**
     * 搜索条件改变时的回调
     */

  }, {
    key: '_onConditionChange',
    value: function _onConditionChange() {
      return new Promise(function ($return, $error) {
        var onFilterChange = this.props.onFilterChange;

        var filter = this.getFilter();
        return Promise.resolve(new Promise(function ($return, $error) {
          var $logicalAnd_4;

          function $IfStatement_10() {
            return $return($logicalAnd_4);
          }

          if ($logicalAnd_4 = (0, _lodashCompat.isFunction)(onFilterChange)) {
            return Promise.resolve(onFilterChange(filter)).then(function ($await_20) {
              $logicalAnd_4 = $await_20;
              return $IfStatement_10.call(this);
            }.$asyncbind(this, $error), $error);
          }

          return $IfStatement_10.call(this);
        }.$asyncbind(this))).then(function ($await_21) {
          return $return();
        }.$asyncbind(this, $error), $error);
      }.$asyncbind(this));
    }

    /**
     * 获取搜索条件
     * @returns {*|OrderedMap<K, V>|OrderedMap<string, V>|condition|string|string}
     */

  }, {
    key: '_getCondition',
    value: function _getCondition() {
      return this.state.condition;
    }

    /**
     * 接受多组键值对更新
     * value = '' | { label, value } | [{ label, value }, { label, value }, ...] //字段值
     * @param kvMap = { key1: value1, key2: value2, ... }
     * @param isTemporary 是否是暂存搜索条件
     * @private
     */

  }, {
    key: '_setCondition',
    value: function _setCondition(kvMap, isTemporary, dontNotice, dontSearch) {
      return new Promise(function ($return, $error) {
        function $IfStatement_11() {
          return $return();
        }

        if (isTemporary) {
          this.temporaryCondition = kvMap;
          return $IfStatement_11.call(this);
        } else {
          // 将暂存的条件也更新上，这样当其他操作（比如直接删除搜索条件）更新搜索条件时不会丢失暂存
          if (this.temporaryCondition) {
            kvMap = Object.assign({}, this.temporaryCondition, kvMap);
            this.temporaryCondition = null;
          }
          var _state2 = this.state;
          var condition = _state2.condition;
          var dataColumns = _state2.dataColumns;


          for (var k in kvMap) {
            var v = kvMap[k];
            if (['', null, undefined].includes(v) || v.length == 0) {
              condition = condition.delete(k);
            } else {
              condition = condition.set(k, v);
            }
            //如果清除的是表头筛选的字段
            var column = dataColumns.get(k);
            if (column) {
              var filteredFullValue = ((0, _lodashCompat.isArray)(v) ? v : [v]).filter(function (item) {
                return !!item;
              });
              var filteredValue = filteredFullValue.map(function (item) {
                return (0, _lodashCompat.isObject)(item) ? (0, _lodashCompat.get)(item, 'value') : item;
              });
              dataColumns = dataColumns.set(k, Object.assign(column, {
                filterDropdownVisible: false,
                filtered: filteredFullValue.length > 0,
                filteredFullValue: filteredFullValue,
                filteredValue: filteredValue
              }));
            }
          }

          var changedKeys = (0, _lodashCompat.isObject)(kvMap) && Object.keys(kvMap) || [];
          var newState = {
            condition: condition,
            changedKeys: changedKeys,
            dataColumns: dataColumns
          };
          return Promise.resolve(this.setStateAsync(newState)).then(function ($await_22) {
            return Promise.resolve(new Promise(function ($return, $error) {
              var $logicalAnd_5;

              function $IfStatement_12() {
                return $return($logicalAnd_5);
              }

              if ($logicalAnd_5 = !dontNotice) {
                return Promise.resolve(this._onConditionChange()).then(function ($await_23) {
                  $logicalAnd_5 = $await_23;
                  return $IfStatement_12.call(this);
                }.$asyncbind(this, $error), $error);
              }

              return $IfStatement_12.call(this);
            }.$asyncbind(this))).then(function ($await_24) {
              return Promise.resolve(new Promise(function ($return, $error) {
                var $logicalAnd_6;

                function $IfStatement_13() {
                  return $return($logicalAnd_6);
                }

                if ($logicalAnd_6 = !dontSearch) {
                  return Promise.resolve(this.search()).then(function ($await_25) {
                    $logicalAnd_6 = $await_25;
                    return $IfStatement_13.call(this);
                  }.$asyncbind(this, $error), $error);
                }

                return $IfStatement_13.call(this);
              }.$asyncbind(this))).then(function ($await_26) {
                return $IfStatement_11.call(this);
              }.$asyncbind(this, $error), $error);
            }.$asyncbind(this, $error), $error);
          }.$asyncbind(this, $error), $error);
        }
      }.$asyncbind(this));
    }

    /**
     * 获取当前变化的字段主键集合
     * @returns {V[]|Array<V>|*|changedKeys|Array}
     */

  }, {
    key: '_getChangedKeys',
    value: function _getChangedKeys() {
      return this.state.changedKeys.slice();
    }

    /**
     * 获取数据标识的字段名
     * @returns {string}
     */

  }, {
    key: '_getIdField',
    value: function _getIdField() {
      var model = this.props.model;

      return model.idField;
    }

    /**
     * 获取搜索条件model键值对
     * @returns {{}|*}
     */

  }, {
    key: '_getSearchFieldsMap',
    value: function _getSearchFieldsMap() {
      return _extends({}, this.state.searchFieldsMap);
    }

    /**
     * 获取已选中数据项的完整对象列表，不包括在当前数据中不存在的条目
     * @returns {Array<Object>}
     */

  }, {
    key: '_getSelection',
    value: function _getSelection() {
      var _state3 = this.state;
      var data = _state3.data;
      var selection = _state3.selection;

      var dataById = _util2.default.toObject(data, this._getIdField());
      return selection.map(function (item) {
        return dataById[item];
      }).filter(Boolean);
    }

    /**
     * 获取列表项
     */

  }, {
    key: '_getColumns',
    value: function _getColumns() {
      return this.state.dataColumns.toArray();
    }

    /**
     * 设置全部列表项
     * @param columns
     * @param cb
     */

  }, {
    key: '_setColumns',
    value: function _setColumns(columns, cb) {
      this.setState({
        dataColumns: (0, _immutable.OrderedMap)(columns.map(function (d) {
          return [d.code, d];
        }))
      }, cb);
    }

    /**
     * 设置单列
     * @param code
     * @param column
     * @param cb
     */

  }, {
    key: '_setFieldColumn',
    value: function _setFieldColumn(code, column, cb) {
      var dataColumns = this.state.dataColumns;

      this.setState({
        dataColumns: dataColumns.set(code, column)
      }, cb);
    }
  }, {
    key: '_getScroll',
    value: function _getScroll() {
      return _extends({}, this.state.gridScroll);
    }
  }, {
    key: '_setScroll',
    value: function _setScroll(gridScroll) {
      this.setState({ gridScroll: gridScroll });
    }

    /**
     * 当搜索字段调整排序或显示状态时
     * @param currentFields 当前展示的字段
     * @param allFields 所有的字段
     */

  }, {
    key: '_onSearchFieldsFilter',
    value: function _onSearchFieldsFilter(currentFields, allFields) {
      var onSearchFieldsFilter = this.props.onSearchFieldsFilter;

      for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
        args[_key - 2] = arguments[_key];
      }

      onSearchFieldsFilter && onSearchFieldsFilter.apply(undefined, [currentFields, allFields].concat(args));
    }

    /**
     * 当列表字段调整排序或显示状态时
     * @param currentColumns 当前展示的列
     * @param allColumns 所有的列
     */

  }, {
    key: '_onColumnsFilter',
    value: function _onColumnsFilter(currentColumns, allColumns) {
      var onColumnsFilter = this.props.onColumnsFilter;

      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      onColumnsFilter && onColumnsFilter.apply(undefined, [currentColumns, allColumns].concat(args));
    }

    /**
     * 操作时触发的事件，一般会在操作面板中的按钮被点击时调用
     * @param data 操作关联的数据
     * @param model 操作按钮的配置
     * @param args
     */

  }, {
    key: '_action',
    value: function _action(data, model) {
      for (var _len3 = arguments.length, args = Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++) {
        args[_key3 - 2] = arguments[_key3];
      }

      return new Promise(function ($return, $error) {
        var _this4 = this;

        var action = model.action || this.defaultActions[model.code];
        if (action == null) return $return(null);
        //传出的数据中增加ids方法可以直接获取主键数组
        data.ids = function () {
          return data.map((0, _lodashCompat.property)(_this4._getIdField()));
        };
        return Promise.resolve(action.apply(undefined, [this, data, model].concat(args))).then(function ($await_27) {
          return $return();
        }.$asyncbind(this, $error), $error);
      }.$asyncbind(this));
    }

    /**
     * 渲染一行数据的操作面板
     * 针对type为console的列，如果未对该列传入buttons，则默认用定义在全局的buttons
     */

  }, {
    key: '_renderRowConsole',
    value: function _renderRowConsole(data, model) {
      var _props3 = this.props;
      var prefixCls = _props3.prefixCls;
      var m = _props3.model;

      var buttons = model.buttons || m.console.buttons;
      return _react2.default.createElement(ComplexRecords.Console, { className: prefixCls + '-complex-records__row-console',
        model: { buttons: buttons },
        data: [data], inRow: true });
    }

    /**
     * 重置搜索条件
     */

  }, {
    key: 'reset',
    value: function reset() {
      var _this5 = this;

      var _state4 = this.state;
      var condition = _state4.condition;
      var dataColumns = _state4.dataColumns;

      var changedKeys = condition.keySeq().toArray();
      changedKeys.forEach(function (k) {
        //如果清除的是表头筛选的字段，同时清空高亮状态
        var column = dataColumns.get(k);
        if (column) {
          dataColumns = dataColumns.set(k, Object.assign(column, {
            filtered: false,
            filteredFullValue: [],
            filteredValue: []
          }));
        }
      });

      this.setState({
        condition: condition.clear(),
        changedKeys: changedKeys,
        dataColumns: dataColumns
      }, function () {
        return new Promise(function ($return, $error) {
          return Promise.resolve(this._onConditionChange()).then(function ($await_28) {
            return Promise.resolve(this.search()).then(function ($await_29) {
              return $return();
            }.$asyncbind(this, $error), $error);
          }.$asyncbind(this, $error), $error);
        }.$asyncbind(_this5));
      });
    }

    /**
     * 重置为第一页并搜索数据
     * 搜索条件改变后，可能当前页没有数据了
     */

  }, {
    key: 'search',
    value: function search() {
      return new Promise(function ($return, $error) {
        function $IfStatement_14() {
          return $return();
        }

        // 如果存在暂存搜索条件，则确认设置搜索条件
        if (this.temporaryCondition) {
          return Promise.resolve(this._setCondition(this.temporaryCondition)).then(function ($await_30) {
            this.temporaryCondition = null;
            return $IfStatement_14.call(this);
          }.$asyncbind(this, $error), $error);
        } else {
          // 否则直接搜索
          this.setState({ pageNo: 1 }, this._fetchData);
          return $IfStatement_14.call(this);
        }
      }.$asyncbind(this));
    }

    /**
     * 获取当前搜索条件
     */

  }, {
    key: 'getFilter',
    value: function getFilter() {
      var _state5 = this.state;
      var condition = _state5.condition;
      var pageNo = _state5.pageNo;
      var pageSize = _state5.pageSize;
      var searchFieldsMap = _state5.searchFieldsMap;

      var page = { pageNo: pageNo, pageSize: pageSize };
      var filter = { page: page };
      condition.forEach(function (v, k) {
        Object.assign(filter, (0, _util3.convertData)(v, searchFieldsMap[k]));
      });
      return filter;
    }

    /**
     * 控制字段属性，仅支持complex模式
     * @param {*} control 
     */

  }, {
    key: 'doControl',
    value: function doControl(control) {
      if (this.props.mode === 'complex') {
        this.searchArea._doControl(control);
      }
    }

    /**
     * 设置搜索条件
     * @param {*} data 
     */

  }, {
    key: 'setFieldsFilter',
    value: function setFieldsFilter(data) {
      return new Promise(function ($return, $error) {
        return Promise.resolve(this._setCondition(data, null, true, true)).then(function ($await_31) {
          return $return();
        }.$asyncbind(this, $error), $error);
      }.$asyncbind(this));
    }

    /**
     * 默认操作
     * 当传入button的code与action相同并没有自定义action时
     */


    /**
     * 默认分页大小
     */

  }]);

  return ComplexRecords;
}(_util2.default.BaseComponent.Mixin(_util2.default.ContextMixin.ChildGetter({
  records: function records() {
    return this;
  }
}))), _class.propTypes = {
  prefixCls: _propTypes2.default.string,
  model: _propTypes2.default.shape({
    search: _propTypes2.default.shape({
      mode: _propTypes2.default.oneOf(['simple', 'complex']), //模式
      fields: _propTypes2.default.array, //搜索字段
      events: _propTypes2.default.array, //字段绑定事件
      filter: _propTypes2.default.bool, //是否开启字段筛选设置
      advanced: _propTypes2.default.bool })
  })
}, _class.defaultProps = {
  prefixCls: 'mt',
  mode: 'complex'
}, _temp);


ComplexRecords.Search = _component.Search;
ComplexRecords.SearchCondition = _component.SearchCondition;
ComplexRecords.Console = _component.Console;
ComplexRecords.Setting = _component.Setting;
ComplexRecords.DataGrid = _component.DataGrid;

exports.default = ComplexRecords;